<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12">
        <v-autocomplete
          outlined
          multiple
          hide-details
          return-object
          dense
          chips
          item-value="id"
          item-text="title"
          no-data-text="Список пуст"
          placeholder="Начните вводить для поиска..."
          :items="chosenItems"
          :value="listItem.data.where.id"
          :disabled="isQueriesLoading"
          :loading="isQueriesLoading"
          :search-input.sync="search"
          @change="updateValueHandler"
        >
          <template #item="data">
            <v-col>
              <v-list-item-title>{{ data.item.title }}</v-list-item-title>
              <v-list-item-subtitle v-if="data.item.type === 'EVENT'">
                Событие
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="data.item.type === 'PLACE'">
                Место
              </v-list-item-subtitle>
            </v-col>
          </template>
          <template #selection="data">
            <draggable
              :id="data.index"
              :list="listItem.data.where.id"
              v-bind="dragOptionsChips"
              :move="move"
              @change="change({ value: $event, dragged })"
            >
              <v-chip
                draggable
                label
                :value="listItem.data.where.id[data.index]"
                :key="data.item.id"
                @mousedown.stop
                @click.stop
              >
                {{data.item.title}}
              </v-chip>
            </draggable>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import eventsQuery from '@/services/gql/types/Events/queries/eventsGrid.gql'
import placesQuery from '@/services/gql/types/Places/queries/placesGrid.gql'
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix'
import dayjs from 'dayjs'

export default {
  name: 'EventsPlacesRelationChosenWidgetInput',
  mixins: [dynamicListItemMix],
  components: {
    draggable
  },
  data () {
    return {
      search: null,
      dragged: {
        from: -1,
        to: -1,
        newIndex: -1
      },
      selectedSync: [2],
      events: [],
      places: []
    }
  },
  mounted () {
    const value = [...this.listItem.data.where.id]
    this.events = value.filter(item => item.type === 'EVENT')
    this.places = value.filter(item => item.type === 'PLACE')
  },
  computed: {
    dragOptionsChips () {
      return {
        animation: 200,
        group: 'group',
        disabled: false,
        ghostClass: 'ghost',
        sort: true
      }
    },
    chosenItems () {
      return [...this.listItem.data.where.id, ...this.events, ...this.places]
    },
    isQueriesLoading () {
      return this.$apollo.queries.events.loading || this.$apollo.queries.places.loading
    }
  },
  methods: {
    change ({ value, dragged }) {
      if (value.removed) {
        // insert
        this.listItem.data.where.id.splice(
          dragged.to + dragged.newIndex, 0, this.listItem.data.where.id[dragged.from]
        )
        // delete
        if (dragged.from < dragged.to) {
          this.listItem.data.where.id.splice(dragged.from, 1)
        } else {
          this.listItem.data.where.id.splice(dragged.from + 1, 1)
        }
      }
    },
    updateValueHandler (value) {
      this.search = null
      this.mixChangeListItemHandler({ id: value }, 'where')
    },
    move (value) {
      this.dragged = {
        from: parseInt(value.from.id),
        to: parseInt(value.to.id),
        newIndex: value.draggedContext.futureIndex
      }
    }
  },
  apollo: {
    events: {
      fetchPolicy: 'network-only',
      debounce: 1000,
      query: eventsQuery,
      skip () {
        return this.search ? false : !this.value
      },
      variables () {
        // const where = {}
        // if (this.search) where.title_contains = this.search
        const where = {}
        if (this.search) where.title_contains = this.search
        else where.id_in = this.value
        return { where, from: dayjs().startOf('day').utc(true).format() }
      },
      result ({ data }) {
        this.events = data.events.list.map(item => ({ type: 'EVENT', id: item.id, title: item.title }))
      }
    },
    places: {
      fetchPolicy: 'network-only',
      debounce: 1000,
      query: placesQuery,
      skip () {
        return this.search ? false : !this.value
      },
      variables () {
        // const where = {}
        // if (this.search) where.title_contains = this.search
        const where = {}
        if (this.search) where.title_contains = this.search
        else where.id_in = this.value
        return { where }
      },
      result ({ data }) {
        this.places = data.places.list.map(item => ({ type: 'PLACE', id: item.id, title: item.title }))
      }
    }
  }
}
</script>
